import 'css-chunksrc/client/common/filterMenu/roles/styles.scss';export default {
  "header": "_header_vsipt_1",
  "icon": "_icon_vsipt_10",
  "title": "_title_vsipt_18",
  "list": "_list_vsipt_25"
};